import { Card, CardContent, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import strings from '../../../Globalization';
import { useAdvantageCycleInfo } from '../Context';
import { ChartsJson } from './ChartsJson';

const Charts = ({ property }) => {
	const { data: cycle } = useAdvantageCycleInfo();

	const data = cycle.ISAChartData[property];

	if (!data) {
		return (
			<Grid container spacing={2}>
				<Grid size={12}>
					<Card>
						<CardContent>
							<Typography color="error">
								{strings['NoChartDataAvailableForCycle']}
							</Typography>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		);
	}

	const sx = {
		borderTop: (theme) => `1px solid ${theme.palette.divider}`,
		borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
		padding: (theme) => theme.spacing(1)
	};

	return (
		<Grid container spacing={2}>
			<Grid size={12}>
				<Card>
					<CardContent sx={{ paddingTop: 4, paddingBottom: 4 }}>
						<Grid size={12} container spacing={8}>
							{
								ChartsJson.ISA.map((chartData, index) => {
									const { dataKey,
										component: ChartComponent,
										minValue,
										maxValue,
										lowerLimit,
										upperLimit,
										unit } = chartData.params;
									if (!data[dataKey]) {
										return null;
									}
									const { title, subTitleDataKey, subTitle } = chartData;
									const subtitle = data[subTitleDataKey] || subTitle || '';
									const updatedChartName = `${strings[title]} ${subtitle}`;
									return (
										<Grid xs={12} lg={8} md={6} key={index}>
											<ChartComponent
												data={data[dataKey]}
												maxValue={data[dataKey][maxValue]}
												minValue={data[dataKey][minValue]}
												lowerLimit={data[dataKey][lowerLimit]}
												upperLimit={data[dataKey][upperLimit]}
												unit={data[dataKey][unit]}
												title={updatedChartName}
												sx={sx}
											/>
										</Grid>
									)
								})
							}
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default memo(Charts);